// import {storage} from '../../firebase/firebaseConfig'
export default {
  data: function (){
    return {
    }
  },
  methods: {
    goto(name) {
      if (this.$router.currentRoute.name !== name) {
        this.$router.push({name: name})
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    maskPath () {
      return window.location.host.includes('dev') ? 'masksdev' : 'masks'
    }
  }
}
